import dayjs from "dayjs";

function formatDate(date, format = 'MM/DD/YYYY') {
  return dayjs(date).format(format);
}

export default formatDate;
